import React, { useState } from "react";
import { ETestingTaskState, ESuiteMode } from "../../../../Model/ModuleState";
import TabPanel from "../../../PlateTypeEditor/TabPanel";
import CommonDropDown from "../../../Common/DropDown/CommonDropDown";
import PsrCameraManualControl, {
  PSR_CAMERA_MANUAL_ACCORDION_STATE,
} from "../../../Settings/Control/PsrCameraManualControl";
import ReliabilityTest from "./ReliabilityTest";
import ScanningTest from "./ScanningTest";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import { getSuiteMode } from "../../../../redux/reducers/ModuleStateReducer";
import PsrManualControl from "./PsrManualControl";

const categoryDisplayValues = [
  {
    display: "Reliability Testing (Store & Retrieve)",
    value: ETestingTaskState.Reliability,
    disabled: false,
  },
  {
    display: "Scanning Testing",
    value: ETestingTaskState.Barcode,
    disabled: false,
  },
];

type Props = {
  activeCategory: ETestingTaskState;
  setActiveCategory: (value: ETestingTaskState) => void;
  psrIdentifier: string;
  psrCameraId: number;
};

function getInitialChevronButtonDegree(key: string): number {
  const value = localStorage.getItem(key);
  if (value != null) {
    const objVal = JSON.parse(value) as boolean[];
    if (objVal.every((val) => val)) {
      return 180;
    }
    return 0;
  } else {
    return 0;
  }
}

export default function TestingPsrCommandPanel({
  activeCategory,
  setActiveCategory,
  psrIdentifier,
  psrCameraId,
}: Props) {
  const suiteMode = useTypedSelector((state) => getSuiteMode(state));
  const [triggerExpandSetting, setTriggerExpandSetting] = useState(false);
  const [chevronButtonDegree, setChevronButtonDegree] = useState(
    getInitialChevronButtonDegree(PSR_CAMERA_MANUAL_ACCORDION_STATE)
  );
  const isDisabled = suiteMode !== ESuiteMode.Normal;

  const onAllChildrenCollapsed = (collapsed: boolean) => {
    if (collapsed) {
      setChevronButtonDegree(0);
    } else {
      setChevronButtonDegree(180);
    }
  };
  return (
    <div
      style={{
        backgroundColor: "white",
        height: "100%",
        overflow: "auto",
        fontSize: 14,
        WebkitBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        MozBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <TabPanel
        id="testing-imager-tab"
        collapsible={false}
        disabled={false}
        allowChange={!isDisabled}
        activeTabStyle={{ padding: 0 }}
        chevronButton="double"
        onTriggerExpand={() => setTriggerExpandSetting(true)}
        chevronButtondegree={chevronButtonDegree}
        style={{ height: "100%" }}
      >
        {{
          Testing: (
            <div className="testing-panel">
              <div className="testing-category">
                <label>Testing Option :</label>
                <CommonDropDown
                  id="testing-psr-selector"
                  value={activeCategory}
                  onChange={setActiveCategory}
                  dropDownDisplayValues={categoryDisplayValues}
                  style={{ height: 24, width: 384 }}
                  disabled={isDisabled}
                />
              </div>
              {activeCategory === ETestingTaskState.Reliability && (
                <ReliabilityTest />
              )}
              {activeCategory === ETestingTaskState.Barcode && <ScanningTest />}
            </div>
          ),
          "Control Panel":
            psrCameraId > -1 ? (
              <PsrCameraManualControl
                disabled={false}
                psrCameraId={psrCameraId}
                psrIdentifier={psrIdentifier}
                headerEnabled={false}
                triggerExpandAll={triggerExpandSetting}
                setTriggerExpandAll={setTriggerExpandSetting}
                onAllItemCollapsed={onAllChildrenCollapsed}
              />
            ) : (
              <PsrManualControl psrIdentifier={psrIdentifier} />
            ),
        }}
      </TabPanel>
    </div>
  );
}
